module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index"
  }, [(_vm.isDianDianHome) ? _c('div', {
    staticClass: "fi-mobile"
  }, [_c('fi-header-mobile', {
    attrs: {
      "is-mark": _vm.oMark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "banner-main"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "ht"
  }, [_c('h2', [_vm._v("点点商城")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("年轻人的in生活指南")])]), _vm._v(" "), _c('span', [_vm._v("点一点，汇集时尚潮物，甄选全网低价尖货。 众安保险保障账户安全，为购物保驾护航。")]), _vm._v(" "), _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/flat/mobile/mb-1.png")
    }
  })])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "download-btn",
    on: {
      "click": _vm.downloadMobile
    }
  }, [_vm._v("立即下载")]), _vm._v(" "), _c('div', {
    staticClass: "home-icon"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('fi-footer-mobile'), _vm._v(" "), _c('fi-mark', {
    attrs: {
      "is-mark": _vm.oMark
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isBepoint) ? _c('div', [_c('iframe', {
    staticClass: "fdyx",
    attrs: {
      "src": "https://one.zhongan.com/fcp/fdyx/index.htm"
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jy-list"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg"
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adv-box"
  }, [_c('div', {
    staticClass: "adv-top hz-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "adv-main"
  }, [_c('div', {
    staticClass: "ys-main"
  }, [_c('ul', [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35412698"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/flatindexmobile2.vue
// module id = 346
// module chunks = 1